import { render, staticRenderFns } from "./ResellerReport.vue?vue&type=template&id=c642509c&"
import script from "./ResellerReport.vue?vue&type=script&lang=js&"
export * from "./ResellerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports